<template>
  <footer class="bg-untitled-gray-100 sticky z-[-1] mt-auto">
    <div class="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
      <!-- <nav
        class="-mx-5 -my-2 flex flex-wrap justify-center"
        aria-label="Footer"
      >
        <div v-for="item in navigation.main" :key="item.name" class="px-5 py-2">
          <a
            :href="item.href"
            class="text-base text-untitled-gray-500 hover:text-untitled-gray-900"
          >
            {{ item.name }}
          </a>
        </div>
      </nav> -->
      <p class="mt-8 text-center text-base text-gray-400">
        &copy; DavidLong {{ new Date().getFullYear() }} - All rights reserved.
      </p>
      <p class="mt-4 text-center text-xs text-gray-400 italic">
        Disclaimer: All videos and training materials on the David J Long Consulting LMS are protected under copyright law. Downloading, reproducing, sharing, or using this content on other platforms without prior written consent is strictly prohibited.
      </p>
    </div>
  </footer>
</template>
<script setup>
// const navigation = {
//   main: [
//     { name: 'Reports', href: '#' },
//     { name: 'Mystery Shops', href: '#' },
//     { name: 'File Manager', href: '#' },
//     { name: 'Profile', href: '#' },
//   ],
// };
</script>
